import { signal } from '@preact/signals-react';
// NOTE: Kept outside SpeakersModal so that the running recompute survives closing the modal.
export const recomputingSpeakersSignal = signal(false);
export const setRecomputingSpeakersSignal = (isRecomputing) => {
    recomputingSpeakersSignal.value = isRecomputing;
};
